module.exports = __webpack_public_path__ + "static/media/email-icon.ed8ec9cf.svg";